import { gql } from "@apollo/client";

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_ONE_USER_FOLLOWUP = gql`
  mutation UpdateOneUserFollowup(
    $data: UserFollowupUpdateInput!
    $where: UserFollowupWhereUniqueInput!
  ) {
    updateOneUserFollowup(data: $data, where: $where) {
      id          
      title               
      description         
      status              
      currentProgress  
      createdBy           
      createdByID         
      createDate
      followupDate          
      updatedAt           
      updatedBy           
      updatedByFullName   
      evaluationSectionId              
      assignedUserId     
      assignedToUserId     
    }
  }
`;

export const DELETE_ONE_USER_FOLLOWUP = gql`
  mutation DeleteOneUserFollowup(
    $where: UserFollowupWhereUniqueInput!
  ) {
    deleteOneUserFollowup(where: $where) {
      id           
    }
  }
`;

export const CREATE_ONE_USER_FOLLOWUP = gql`
  mutation CreateOneUserFollowup($data: UserFollowupCreateInput!) {
    createOneUserFollowup(data: $data) {
      id          
      title               
      description         
      status              
      currentProgress  
      createdBy           
      createdByID         
      createDate
      followupDate          
      updatedAt           
      updatedBy           
      updatedByFullName   
      evaluationSectionId              
      assignedUserId      
      assignedToUserId      
    }
  }
`;

export const SEND_FOLLOWUP_ASSIGNMENT_NOTIFICATION = gql`
  mutation SendFollowupAssignmentNotification($followupId: String!) {
    sendFollowupAssignmentNotification(followupId: $followupId)
  }
`; 